module.exports = __webpack_public_path__ + "media/dance_mid.fdafabe1.mp3";